import { useEffect } from "react";
import loading from "../../assets/vw/svg/loading.svg";

const Loading = () => {
    
    useEffect(() => {
        
    }, [])

    return (
        <>
            <div style={{ zIndex: '1060', position: 'fixed',top:0, display: 'flex', width: '100%', height: '100vh', justifyContent: 'center', alignItems: 'center', backgroundColor: '#000000a6', left:'0%' }}>
            <div className="container_icon">
                  <div className="icon-vw icon-vw-4">
                    <span>
                      <img src={loading} alt="" className="" />
                    </span>
                  </div>
                </div>
            
            </div>
        </>
    );
}

export default Loading;